import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/*
 * stylesheets/admin/theme.css の @theme で追加したフォントサイズ・寸法を tailwind-merge に教える。
 * 登録しないと text-body 等が文字色と判定され、cn('text-body', 'text-tt-foreground-sub') で text-body が消える。
 * 色（--color-*）は未知の名前も色として扱われるため登録不要。
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['micro', 'caption', 'body-sm', 'body', 'subtitle', 'title', 'heading'],
      container: ['body-tablet', 'body-pc', 'product-card-stack'],
    },
  },
});

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
